<div class="d-none d-lg-block">
  <div class="banner" role="banner">
    <h1>{{ 'wallet.page.title' | translate }}</h1>
  </div>
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="d-lg-none d-block">
  <fgb-barcode [isWalletPage]="true"></fgb-barcode>
</div>

<!-- V2 Wallet -->
<ng-container *ngIf="walletItems?.length > 0; else noWalletItems">
  <div class="wallet-redeem-carousel pt-4">
    <div class="container">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
    </div>
  </div>
</ng-container>

<ng-template #noWalletItems>
  <div class="container">
    <h4 class="no-wallet-items pt-4 mb-3 fw-bold">{{ 'rewards.wallet.no.items' | translate }}</h4>
    <div class="border rounded">
      <div class="no-wallet-items-description font-size-12 text-center py-3">
        {{ 'rewards.wallet.no.items.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>

<div class="container mt-3 text-center mb-5">
  <div class="claimed-button bg-white">
    <div class="claimed-button-text">
      <h5 class="font-size-14 mb-1">REDEMPTION HISTORY</h5>
      <div class="font-size-14">View history of your redemptions</div>
    </div>
    <a
      class="font-size-14 claimed-text fw-bold btn btn-white border-primary rounded text-primary wallet-claimed-button"
      [routerLink]="['/rewards/claimed']"
    >
      {{ 'rewards.wallet.view.claimed' | translate }}
    </a>
  </div>
</div>
